import React, { useState, useEffect } from 'react';
import api from '../../services/api';

const AdminDrivers = () => {
  const [drivers, setDrivers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    password: ''
  });

  const fetchDrivers = async () => {
    try {
      setLoading(true);
      const { data } = await api.get('/drivers').catch(() => ({ data: { data: [] } }));
      setDrivers(data.data || []);
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDrivers();
  }, []);

  const toggleAvailability = async (driver) => {
    try {
      await api.put(`/drivers/${driver.id}/status`, {
        isAvailable: !driver.is_available
      });
      fetchDrivers();
    } catch (error) {
      alert('Error: ' + (error.response?.data?.message || error.message));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post('/auth/register', { ...formData, role: 'motorizado' });
      setShowModal(false);
      setFormData({ name: '', email: '', phone: '', password: '' });
      fetchDrivers();
    } catch (error) {
      alert('Error: ' + (error.response?.data?.message || error.message));
    }
  };

  return (
    <div>
      <div className="flex flex-wrap justify-between items-center mb-6 gap-4">
        <div>
          <h1 className="text-3xl font-serif font-bold">🚗 Gestionar Motorizados</h1>
          <p className="text-gray-500 text-sm mt-1">{drivers.length} motorizados registrados</p>
        </div>
        <button
          onClick={() => setShowModal(true)}
          className="bg-gold text-white px-6 py-3 rounded-full font-semibold hover:bg-gold-dark transition shadow-md flex items-center gap-2"
        >
          <span className="text-xl">+</span> Nuevo Motorizado
        </button>
      </div>

      {loading ? (
        <div className="text-center py-12">
          <div className="inline-block w-8 h-8 border-4 border-gold border-t-transparent rounded-full animate-spin" />
        </div>
      ) : drivers.length === 0 ? (
        <div className="bg-white rounded-xl p-12 text-center text-gray-500">
          <div className="text-6xl mb-4">🚗</div>
          <p className="text-lg font-medium">No hay motorizados</p>
          <p className="text-sm mt-2">Agrega tu primer motorizado</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {drivers.map(driver => (
            <div key={driver.id} className="bg-white rounded-xl shadow-sm border border-gray-100 p-5 hover:shadow-md transition">
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 rounded-full bg-gradient-to-br from-orange-500 to-orange-600 flex items-center justify-center text-white font-bold text-lg">
                    {driver.name?.charAt(0).toUpperCase() || '?'}
                  </div>
                  <div>
                    <div className="font-semibold">{driver.name}</div>
                    <span className="text-xs text-gray-500">🚗 Motorizado</span>
                  </div>
                </div>
                <button
                  onClick={() => toggleAvailability(driver)}
                  className={`px-3 py-1 rounded-full text-xs font-semibold ${
                    driver.is_available
                      ? 'bg-green-100 text-green-700'
                      : 'bg-red-100 text-red-700'
                  }`}
                >
                  {driver.is_available ? '✅ Disponible' : '❌ Ocupado'}
                </button>
              </div>
              <div className="space-y-1 text-sm">
                <div className="flex items-center gap-2 text-gray-600">
                  <span>📧</span> <span className="truncate">{driver.email}</span>
                </div>
                <div className="flex items-center gap-2 text-gray-600">
                  <span>📱</span> <span>{driver.phone}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <div className="absolute inset-0 bg-black/50" onClick={() => setShowModal(false)} />
          <div className="relative bg-white rounded-2xl shadow-2xl max-w-md w-full">
            <div className="p-6 border-b border-gray-100 flex justify-between items-center">
              <h2 className="text-2xl font-serif font-bold">➕ Nuevo Motorizado</h2>
              <button onClick={() => setShowModal(false)} className="text-2xl hover:text-gold">✕</button>
            </div>
            <form onSubmit={handleSubmit} className="p-6 space-y-4">
              <div>
                <label className="block text-sm font-medium mb-1">Nombre *</label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={e => setFormData({...formData, name: e.target.value})}
                  className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-gold"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Email *</label>
                <input
                  type="email"
                  value={formData.email}
                  onChange={e => setFormData({...formData, email: e.target.value})}
                  className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-gold"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Teléfono *</label>
                <input
                  type="tel"
                  value={formData.phone}
                  onChange={e => setFormData({...formData, phone: e.target.value})}
                  className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-gold"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium mb-1">Contraseña *</label>
                <input
                  type="password"
                  value={formData.password}
                  onChange={e => setFormData({...formData, password: e.target.value})}
                  className="w-full px-4 py-2 border rounded-lg focus:ring-2 focus:ring-gold"
                  required
                />
              </div>
              <div className="flex gap-3 pt-4">
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  className="flex-1 py-3 border rounded-full hover:bg-gray-50 transition"
                >
                  Cancelar
                </button>
                <button
                  type="submit"
                  className="flex-1 py-3 bg-gold text-white rounded-full hover:bg-gold-dark transition font-semibold"
                >
                  Crear Motorizado
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminDrivers;
